import React, { useContext } from 'react'
import BoxMask from 'components/BoxMask'
import styled from 'particles/themes/styled'
import { EDITOR_ROUTE_ENUM, ViewTypeContext } from 'components/Campaign'

export const MaskContainer = styled.div`
    height: fit-content;
    width: 100%;
    position: relative;
`

const MaskWrapper: React.FC = ({ children }) => {
    const viewType = useContext(ViewTypeContext)
    return (
        <>
            {viewType === EDITOR_ROUTE_ENUM.VIEW ? (
                <MaskContainer>
                    <BoxMask />
                    {children}
                </MaskContainer>
            ) : (
                <>{children}</>
            )}
        </>
    )
}

export default MaskWrapper
